import { ButtonERP, Dialog, TagERP } from "@finanedi.es/storybook"
import { faDownload, faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DeclaracionModelo390DtoProps } from "api/DTOs/DeclaracionModelo390Dto"
import { postDeclaracionModelo390 } from "api/DeclaracionModelo"
import notification from "common/utils/notification"
import { Dispatch, SetStateAction } from "react"
import { UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { removeNullAndZeroValues } from "utils/removeNullAndZeroValue"
import { postModeloDeclaracion390Adapter } from "../postDeclaracionModelo390.adapter"

export const ModalPresentarModelo390 = ({
  show,
  setShow,
  watch,
}: {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  watch: UseFormWatch<DeclaracionModelo390DtoProps>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const submitModelo = async (data: DeclaracionModelo390DtoProps) => {
    const formData = postModeloDeclaracion390Adapter(data)
    const cleanedData = removeNullAndZeroValues(formData)
    try {
      const blobResponse = await postDeclaracionModelo390({
        declaracionModelo390: cleanedData,
      })
      const blob = new Blob([blobResponse], { type: "text/plain" })
      const link = document.createElement("a")

      link.href = URL.createObjectURL(blob)
      link.download = "modelo390.txt"
      link.click()

      URL.revokeObjectURL(link.href)
      notification.success({ body: `${t("successMsg.downloadDocument")}` })
      setShow(!show)
    } catch (error) {
      notification.errorServidor({
        body: `${t("errorMsg.downloadDocument")}`,
      })
      setShow(!show)
    }
  }

  return (
    <Dialog
      header={`${t("modelo390.modal.title")}`}
      headerClassName='!tw-text-lg'
      visible={show}
      onHide={() => setShow(!show)}
      maskClassName='!tw-p-6'
      className='!tw-mt-6 !tw-w-96'
      baseZIndex={30}
      draggable
    >
      <div className='tw-w-full tw-flex tw-gap-3 tw-flex-col tw-text-sm'>
        <TagERP
          color='info'
          icon={<FontAwesomeIcon icon={faInfoCircle} />}
          value={t("modelo390.modal.infoText")}
          className='!tw-rounded-md'
        />
        <div className='tw-w full tw-flex tw-flex-row tw-justify-end'>
          <ButtonERP
            customize={{ type: "primary", size: "md" }}
            label={`${t("taxSummary.declaracion.modal.download")}`}
            onClick={() => submitModelo(values)}
            icon={<FontAwesomeIcon icon={faDownload} />}
          />
        </div>
      </div>
    </Dialog>
  )
}
export default ModalPresentarModelo390
